import React from 'react';
import { connect } from 'react-redux';

import { updateGlove } from '../../actions/creators';
import syncPreview from '../higher-order/SyncPreview';
import CustomPythonButtons from '../CustomPythonButtons';

const RingFinger = ({
  customPythons,
  insideCurrentCustomPython,
  onInsideCustomPythonClick,
  outsideCurrentCustomPython,
  onOutsideCustomPythonClick,
}) => (
  <div className="step-item-view-wrap pull-right">
    <CustomPythonButtons
      title="RING FINGER INSIDE COLOR"
      className="finger-inside-color-wrap"
      images={customPythons}
      currentCustomImage={insideCurrentCustomPython}
      onClick={onInsideCustomPythonClick}
    />
    <CustomPythonButtons
      title="RING FINGER OUTSIDE COLOR"
      className="finger-outside-color-wrap"
      images={customPythons}
      currentCustomImage={outsideCurrentCustomPython}
      onClick={onOutsideCustomPythonClick}
    />
  </div>
);

const mapStateToProps = (state) => {
  const { ringInsidePython, ringOutsidePython } = state.glove;

  return {
    customPythons: state.builder.leatherColors[state.glove.leatherGrade.id],
    insideCurrentCustomPython: ringInsidePython,
    outsideCurrentCustomPython: ringOutsidePython,
  };
};

const mapDispatchToProps = dispatch => ({
  onInsideCustomPythonClick: python => dispatch(updateGlove({ ringInsidePython: python })),
  onOutsideCustomPythonClick: python => dispatch(updateGlove({ ringOutsidePython: python })),
});

export default syncPreview(connect(
  mapStateToProps,
  mapDispatchToProps,
)(RingFinger), 'fingerSide');
